<div *ngIf="hasMoreCount > 0" class="load-more d-flex justify-content-end w-100">
    <button type="button" (click)="buttonClick.emit()">{{'common.load_more' | translate : {hasMoreCount: hasMoreCount} }}</button>
</div>
